
const quickformCheckRequired = require ('./quickform-form-check-required')
const handler                = require('./quickform-form-handler')
const settings               = require('../../js-handler/settings')
const quickform              = require ('./quickform')




//prepare the Quickform to be filled with the data get it from the server
export function prepareAfterInsert(detail, htmlQf, result){ 

    try{

        //clean Quickform 
        clean(htmlQf)
        //console.log('--------------->clean')

        cleanFromValues(htmlQf)
        //console.log('--------------->cleanFromValues')

        //hide quickform
        detail.html = htmlQf.quickformHTML
        detail.act  = 'hide'
        quickform.start(detail)

        //Click on the source autocomplete
        let add       = htmlQf.source;
        let parent_aC = add.parentElement;
        let input_aC  = parent_aC.querySelector('input');
        input_aC.focus();
        input_aC.click();


    }catch(error){ console.log('prepareAfterInsert error', error)}


}/**/



//add to form the values from the inputs 
export function getValues( htmlQf ){ //console.log('getValues>',)

  htmlQf.form.forEach((elem)=>{ //console.log(elem.name, handler.getValues(elem))
       elem.value = handler.getValues(elem)
  })/**/  

  //console.log('getValueForm', htmlQf.form)//lightg

 
  
}/**/




//clean the html elements
export function clean( htmlQf ){ //console.log('clean>', htmlQf)

  htmlQf.form.forEach((elem)=>{
        handler.clean(elem)
  })/**/

}/**/



export function cleanFromValues(htmlQf) { //console.log('cleanFromValuesx>', htmlQf )

  for (let i = 0; i < htmlQf.form.length; i++) {  //console.log('form>', form[i].name )

    htmlQf.formCopy[i].value = ''
    htmlQf.form[i].value     = ''

    if (htmlQf.form[i].type === 'autocomplete') {
      htmlQf.formCopy[i].value = []
      htmlQf.form[i].value     = []
    }

    if (htmlQf.form[i].date) {
      htmlQf.formCopy[i].value = '0000-00-00'
      htmlQf.form[i].value     = '0000-00-00'
    }
    if (htmlQf.form[i].time) {
      htmlQf.formCopy[i].value = '00:00'
      htmlQf.form[i].value     = '00:00'
    }

  }/**/

}/**/



export function checkRequired(htmlQf){ //console.log('check require>')

    var existError = false
   
    if( quickformCheckRequired.formCheck(htmlQf.form) )            {  existError = true }

    return existError
}/**/


export function wasEdited(htmlQf, change){  


  var control         = false
  const settingsData  = settings.getData()
 
  ///control only the update
  var controlChange   = false
  if(change != undefined){ 
     controlChange = true 
     change.userId = settingsData.id
  }
  
  getValues(htmlQf)

  //  console.log('after get values')
  //  console.log('wasEdited> form', htmlQf.form)
  //  console.log('wasEdited> formCopy', htmlQf.formCopy)

  for(let i=0 ; i < htmlQf.form.length ; i++){  //console.log('>>', htmlQf.form[i].name.value  )
      if(htmlQf.formCopy[i].value.toString() != htmlQf.form[i].value.toString()  && htmlQf.formCopy[i].type != 'map') { 

          control = true  
          if(controlChange){ 
             change.input.push ({ elemId: htmlQf.form[i].id, from: htmlQf.form[i].value, to:htmlQf.formCopy[i].value  })
          }

         // changeControl
          // console.log('wasEdited>form',     htmlQf.form[i].id,     htmlQf.form[i].value )
          // console.log('wasEdited>Copy',     htmlQf.formCopy[i].id, htmlQf.formCopy[i].value )
      }

  }/*for*/

 
  return control

}/*wasEdited*/


